module.exports = __webpack_public_path__ + "static/media/majorA1.ae927e6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorA1.wav
// module id = Uhhf
// module chunks = 0